import React, { useMemo, useState } from 'react';
import If from '../If';
import styled from 'styled-components';
import { color } from '@nuvolo/nuux-theme/utils';
import FAIcon from '../FAIcon';

const InfoMessageStyles = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${color('primary', 'dark')};
  font-size: 14px;
`;

const SeeMoreLink = styled.span`
  color: ${color('custom', 'link')};
  text-decoration: underline;
  padding-left: 6px;
  cursor: pointer;
`;

export interface InfoMessageWithSeeMoreProps {
  mainMessage: string;
  seeMoreMessage?: string;
}

const InfoMessageWithSeeMore = ({ mainMessage, seeMoreMessage }: InfoMessageWithSeeMoreProps) => {
  const [showMore, setShowMore] = useState(false);

  const message = useMemo(() => {
    if (showMore && seeMoreMessage) {
      return `${mainMessage} ${seeMoreMessage}`;
    }
    return mainMessage;
  }, [mainMessage, seeMoreMessage, showMore]);

  return (
    <InfoMessageStyles>
      <FAIcon icon="circle-info" />
      <span style={{ paddingLeft: '6px' }}>
        {message}
        {seeMoreMessage && (
          <>
            <If condition={showMore}>
              <SeeMoreLink onClick={() => setShowMore(false)}>See less</SeeMoreLink>
            </If>
            <If condition={!showMore}>
              <SeeMoreLink onClick={() => setShowMore(true)}>See more</SeeMoreLink>
            </If>
          </>
        )}
      </span>
    </InfoMessageStyles>
  );
};

export default React.memo(InfoMessageWithSeeMore);
